import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { identityService } from './identity.service';

@Injectable({ providedIn: 'root' })
export class DataService {
  constructor(private http: HttpClient,private securityService:identityService) { }

  get(url: string, params?: any): Observable<any> {
        let options = { };
        this.setHeaders(options);
        return this.http.get(url, options)
            .pipe(
              map((res: any) => {

                    return res;
                }),
                catchError(this.handleError)
            );
    }

  postWithId(url: string, data: any, params?: any): Observable<any> {
        return this.doPost(url, data, true, params);
    }

  post(url: string, data: any, params?: any): Observable<any> {
        return this.doPost(url, data, false, params);
    }

  putWithId(url: string, data: any, params?: any): Observable<any> {
        return this.doPut(url, data, true, params);
    }

  private doPost(url: string, data: any, needId: boolean, params?: any): Observable<any> {
        let options = { };
        this.setHeaders(options, needId);

        return this.http.post(url, data, options)
            .pipe(
              map((res: any) => {
             
                    return res;
                }),
                catchError(this.handleError)
            );
    }

  private handleErrorblob(err: HttpErrorResponse) {
    return throwError(err);

  }

  delete(url: string, params?: any) {
    let options = {};
    this.setHeaders(options);
    return this.http.delete(url, options)
        .pipe(
          map((result: any) => {
            return result;
          }),
          catchError(this.handleError)


        );
    }

  private handleError(error: any) {
    if (error?.error?.isPaid === true || error?.error?.requiresDocaposteRetry === true) {
      return throwError(() => error);
    }

    if (error.error?.message == undefined) {
    return throwError("error undefined");
  }

  const isErrorEvent = typeof ErrorEvent !== 'undefined' && error.error instanceof ErrorEvent;
  if (isErrorEvent) {
    console.error('Client side network error occurred:', error.error.message);
  } else {
    if (error.error?.errors?.DomainValidations) {
      console.error('Backend -', 
        `status: ${error.status}, statusText: ${error.statusText}, message: ${error.error.errors.DomainValidations[0]}`);
    } else {
      console.error('HTTP Error:', error);
    }
  }
    if(error.error.message == undefined){
      return "error undefined";
    }
        if (error.error && typeof error.error.message === 'string' && error.error.name === 'ErrorEvent') {
      console.error('Client-side network error:', error.error.message);
    } else {
      if (error.error.errors && error.error.errors.DomainValidations)
        console.error('Backend - ' +
          `status: ${error.status}, ` +
          `statusText: ${error.statusText}, ` +
          `message: ${error.error.errors.DomainValidations[0]}`);
      else
        console.error(error);
    }

    if (error.error.errors && error.error.errors.DomainValidations!=null)
      return throwError({ status: error.status, statusText: error.statusText, message: error.error.errors.DomainValidations[0] });
    console.log("handleError error.error.message",error.error.message.includes("Une demande de portabilité est déjà enregistrée"))
    if(error.error.message.includes("Une demande de portabilité est déjà enregistrée")){
      return throwError({ status: error.status, statusText: error.statusText, message: error.error.message });
    }
    if(error.error.message.includes("RIB étranger")){
      return throwError({ status: error.status, statusText: error.statusText, message: error.error.message });
    }
    if(error.error.message.includes("Les informations saisies sont invalides. Veuillez vous rapprocher de l'assistance pour en savoir plus")){
      return throwError({ status: error.status, statusText: error.statusText, message: error.error.message });
    }
    if(error.error.message.includes("Modification du RIB impossible entre le 1er et le 15 du mois.")){
      return throwError({ status: error.status, statusText: error.statusText, message: error.error.message });
    }
    return throwError({ status: error.status, statusText: error.statusText, message: "Une erreur technique est survenue veuillez réessayer dans quelques instants" });
  }

  private doPut(url: string, data: any, needId: boolean, params?: any): Observable<any> {
        let options = { };
        this.setHeaders(options, needId);

        return this.http.put(url, data, options)
            .pipe(
              map((res: any) => {
                    return res;
                }),
                catchError(this.handleError)
            );
    }
 
    private setHeaders(options: any, needId?: boolean){
        if (needId && this.securityService) {
            options["headers"] = new HttpHeaders()
                .append('authorization', 'Bearer ' + this.securityService.GetToken())
                .append('x-requestid', Guid.newGuid());
        }
        else if (this.securityService) {
            options["headers"] = new HttpHeaders()
                .append('authorization', 'Bearer ' + this.securityService.GetToken());
      }
      options["withCredentials"] = true;
     
    }
    downloadFile(url: string, data: any): any {

      var HTTPOptions = {
        headers: new HttpHeaders({
          'Accept': 'application/svg',
          'authorization': 'Bearer ' + this.securityService.GetToken()
        }),
        'responseType': 'blob' as 'blob'
      }
      return this.http.post(url, data, HTTPOptions)
        .pipe(
          map((result: any) => {
            return result;
          }),
          catchError(this.handleErrorblob)
  
  
        );
    }
}
export class Guid {
  static newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}



